import { Component } from 'react';

// styles
import ArrowUpIcon from '@svg/arrows-up.svg';

import s from './scrollToTop.sss';

// icons

/*
  According to https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers,
  MINIMUM_DELAY is setted to 4
*/
const MINIMUM_DELAY = 4;

type ScrollToTopState = {
  visible: boolean;
  intervalId?: ReturnType<typeof setTimeout>;
  step: number;
};

type ScrollToTopProps = {
  scrollLength: number,
  scrollSpeed: number,
};

export class ScrollToTop extends
  Component<ScrollToTopProps, ScrollToTopState> {

  public static defaultProps = {
     
    scrollLength: 200,
     
    scrollSpeed: 200,
  };

  public readonly state = {
    visible: false,
    step: 0,
    intervalId: undefined,
  };

  public constructor(props: ScrollToTopProps) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  public componentDidMount(): void {
    window.addEventListener('scroll', this.handleScroll);
  }

  public componentWillUnmount(): void {
    window.removeEventListener('scroll', this.handleScroll);
  }

  public handleScroll = () => {
    const { visible } = this.state;
    const { scrollLength } = this.props;
    const visibility = window.pageYOffset >= scrollLength;
    if (visible !== null || visibility) {
      this.setState({ visible: visibility });
    }
  };

  public scrollStep = () => {
    const { intervalId, step } = this.state;
    if (window.pageYOffset === 0) {
      clearInterval(intervalId);
      this.setState({
        visible: false,
        intervalId: undefined,
        step: 0,
      });
    }
    window.scroll(0, window.pageYOffset - step);
  };

  public scrollToTop = () => {
    const { scrollSpeed } = this.props;

    const step = MINIMUM_DELAY * window.pageYOffset / scrollSpeed;
    const intervalId = setInterval(this.scrollStep, MINIMUM_DELAY);
    this.setState({
      intervalId,
      step,
    });
  };

  public render() {
    const { visible } = this.state;
    return (
      <span
        className={visible ? s.rootVisible : s.root}
        onClick={this.scrollToTop}
      >
        <ArrowUpIcon
          className={s.icon}
          width='24'
          height='24'
        />
      </span>
    );
  }
}

export default ScrollToTop;
